var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-phone-number-input',_vm._b({ref:"phoneInput",attrs:{"fetchCountry":!_vm.editMode,"noUseBrowserLocale":_vm.editMode},on:{"input":_vm.updatePhoneNumber},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'vue-phone-number-input',_vm.plugin.props,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a194ca2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuePhone.vue
// module id = null
// module chunks = 